import { useState, useContext, useEffect } from 'react';
import { UserContext } from '../../../../../App';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import FiberHouseApi from '../../../../../API/FiberHouseApi';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

import './SelfieUploadPopup.css';

const SelfieUploadPopup = ({ leadId, onClose, cloudFile, searchFiberHouses  }) => {
  const user = useContext(UserContext);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(cloudFile ? cloudFile.url : null);
  const [isDragging, setIsDragging] = useState(false);


  useEffect(() => {
    if (cloudFile && cloudFile.url) {
      setPreviewUrl(cloudFile.url);
    }
  }, [cloudFile]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleUpload = async () => {
    // Add your upload logic here
    if (!selectedFile) return;
    // Show a loading message using SweetAlert
    Swal.fire({
      icon: 'info',
      title: 'Uploading Image',
      text: 'Please wait...',
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      customClass: { container: "custom-swal" },
      didOpen: () => Swal.showLoading(),
    });

    // Create a unique storage path for the image file
    const path = `/images/${user.firebaseId}/${leadId}/${uuidv4()}`;
    try {
      // Upload the file directly using the existing helper function
      const uploadedFile = await uploadFileToFirebase(selectedFile, path);
  
      // // Show a success message once the file is uploaded
      // Swal.fire({
      //   icon: "success",
      //   title: "File Uploaded",
      //   position: 'top',
      //   showConfirmButton: false,
      //   timer: 1500,
      //   customClass: { container: "custom-swal" },
      //   didOpen: () => Swal.hideLoading(),
      // });
  
      // Pass the file details to your API (using AddPitch or a similar function)
      AddSelfieAsync(
        uploadedFile.url,
        uploadedFile.fileType,
        uploadedFile.fileSize,
        uploadedFile.extension,
        uploadedFile.caption,
        uploadedFile.path,
        uploadedFile.name
      );
    } catch (error) {
      console.error('Image upload failed:', error);
    }
  
    // Optionally close the modal or do other cleanup

  };

  const handleAudioUpload = async (audioBlob) => {
          // Swal.fire({
          //     icon: 'info',
          //     title: 'Uploading Audio',
          //     text: 'Please wait...',
          //     showConfirmButton: false,
          //     allowOutsideClick: false,
          //     allowEscapeKey: false,
          //     allowEnterKey: false,
          //     customClass: {
          //         container: "custom-swal"
          //     },
          //     didOpen: () => Swal.showLoading(),
          // });
  
          const file = new File([audioBlob], `audio_${uuidv4()}.webm`, { type: 'audio/webm' });
          const path = `/pitches/${user.firebaseId}/${leadId}/${uuidv4()}`;
  
          try {
              const uploadedFile = await uploadFileToFirebase(file, path);
              // setAudioUrl(uploadedFile.url);  // Update the state with the new file info
              Swal.fire({
                  icon: "success",
                  title: "File Uploaded",
                  position: 'top',
                  showConfirmButton: false,
                  timer: 1500,
  
                  customClass: {
                      container: "custom-swal"
                  },
                  didOpen: () => {
                      Swal.hideLoading();
                  }
  
  
              });
  
              await AddSelfieAsync( uploadedFile.url, uploadedFile.fileType, uploadedFile.fileSize, uploadedFile.extension, uploadedFile.caption, uploadedFile.path,uploadedFile.name);
              onClose();
              
            } catch (error) {
              console.error('Audio upload failed:', error);
          }
      };

  const AddSelfieAsync = async ( Url, FileType, FileSize, Extension, Caption, Path, Name) => {
      
              let req = {
                  LeadId: leadId,
                  Name: Name,
                  Url: Url,
                  FileType: FileType,
                  FileSize: FileSize,
                  Extension: Extension,
                  Caption: Caption,
                  Path: Path
              }
              console.log(`AddSelfie Request: ${req}`);
              const res = await FiberHouseApi.AddSelfie(req);
              console.log(res);
      
              if (res?.status?.success) {
                  Swal.fire({
                      icon: "success",
                      title: "File Added",
                      // position: 'top',
                      showConfirmButton: true,
                      // timer: 1500,
      
                      customClass: {
                          container: "custom-swal"
                      },
                      didOpen: () => {
                          Swal.hideLoading();
                      }
                  });
                  // setReload(prev=>!prev);
                  searchFiberHouses();
      
              } else {
                  Swal.fire({
                      icon: "error",
                      title: "File Not Added",
      
                      text: "Please try again",
                      // position: 'top',
                      showConfirmButton: true,
                      // timer: 1500,
      
                      customClass: {
                          container: "custom-swal"
                      },
                      didOpen: () => {
                          Swal.hideLoading();
                      }
                  });
      
              }
      
      
          }
  const uploadFileToFirebase = async (file, path) => {
          const storage = getStorage();
          const storageRef = ref(storage, path);
          const uploadTask = uploadBytesResumable(storageRef, file);
  
          return new Promise((resolve, reject) => {
              uploadTask.on(
                  'state_changed',
                  (snapshot) => {
                      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                      Swal.update({
                          text: `Uploading File ${progress.toFixed(0)}%`,
                      });
                  },
                  (error) => {
                      console.error(error);
                      Swal.fire({
                          icon: 'error',
                          title: 'Upload Failed',
                          text: `Failed to upload ${file.name}.`,
                          customClass: {
                              container: "custom-swal"
                          },
                          didOpen: () => {
                              Swal.hideLoading()
                          }
                      });
                      reject(error);
                  },
                  async () => {
                      const downloadURL = await getDownloadURL(storageRef);
                      resolve({
                          name: file.name,
                          url: downloadURL,
                          path: path,
                          extension: file.name.split('.').pop(),
                          fileSize: file.size.toString(),
                          fileType: file.type,
                          caption: file.name,
                      });
                  }
              );
          });
      };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="upload-header">
          <h2>
            📸 Upload Your Selfie
          </h2>
          <p className="upload-instructions">
            Please upload a clear photo of yourself facing forward
          </p>
        </div>
        {previewUrl ? (
                <img 
                  src={previewUrl} 
                  alt="Preview" 
                  className="upload-preview"
                />
              ) : (
                <div></div>
              )}

        <div 
          className={`upload-area ${isDragging ? 'dragover' : ''}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <div className="file-input-wrapper">
            <input
              type="file"
              accept="image/*"
              className="file-input"
              onChange={handleFileChange}
              id="fileInput"
            />
            <label htmlFor="fileInput">
              <div>
                  <p>Drag and drop your selfie here</p>
                  <p>or click to browse</p>
                </div>
            </label>
          </div>
        </div>

        {selectedFile && (
          <p className="selected-file">
            Selected: {selectedFile.name}
          </p>
        )}

        <div className="button-group">
          <button 
            className="upload-button"
            onClick={handleUpload}
            disabled={!selectedFile}
          >
            Upload
          </button>
          <button 
            className="close-button"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelfieUploadPopup;